import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function FigureTotals({allLoaded, totalIncome, totalExpenseCF, totalProfitCF, target, profitVSTarget, totalExpensePNL, totalProfitPNL}){
    if(!allLoaded){
        return <LoadingSpinner/>
    }

    const colour = (amount) => {
        if(amount > 0){
            return "table-highlight-green-black-text";
        }
        else if(amount < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange";
    }

    return (
        <div>
            <Title>Totals</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Income (Inc. Vehicle Sales Profits)</th>
                                <th>Total Expenses CF</th>
                                <th>Total Profit CF</th>
                                <th>Target Profit</th>
                                <th>Profit VS Target</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{totalIncome}</td>
                                <td>{totalExpenseCF}</td>
                                <td className={colour(totalProfitCF)}>{totalProfitCF}</td>
                                <td>{target}</td>
                                <td className={colour(profitVSTarget)}>{profitVSTarget}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Expenses PNL</th>
                                <th>Total Profit PNL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{totalExpensePNL}</td>
                                <td className={colour(totalProfitPNL)}>{totalProfitPNL}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );

}